<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I would like to acknowledge the support of my family and friends who always believed in me. I would especially like to thank Jackie Sheline, who gave me invaluable assistance in editing my manuscript. I would like to thank Sequoyah Wasson for her unwavering love and support.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?70f05fb2